import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MapService } from 'src/app/Service/map.service';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
import * as moment from 'moment';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-cctv-film-status',
  templateUrl: './cctv-film-status.component.html',
  styleUrls: ['./cctv-film-status.component.css']
})

export class CctvFilmStatusComponent implements OnInit {

  lst_Parking = [];

  lst_Car = [];

  lst_Report = [];

  lst_Search = [];

  obj_Report: any = {};

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iVS_Parking: new FormControl('-1'),

    strUnitID: new FormControl(''),

    strSDate: new FormControl(momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.initialization()

  }

  async initialization() {

    this._otherService.Showspinner();

    let response = JSON.parse((await axios.post(`VS_Parking_List`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1dxzOPwsZ' } });

      return;

    }

    if (response.iResult == 0) return this._tooltip.showError(response.strError);

    this.lst_Parking = response;

    // -------------------------------------------------------------

    this._otherService.Showspinner();

    let response_2 = JSON.parse((await axios.post(`Dashcam_List4Search`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response_2.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwsZ' } });

      return;

    }

    if (response_2.iResult == 0) return this._tooltip.showError(response_2.strError);

    this.lst_Car = response_2;

    // -------------------------------------------------------------

  }

  async getReport() {

    this._otherService.Showspinner();

    let response = JSON.parse((await axios.post(`VS_EvacuationReport_Search`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {

      this._tooltip.showError('نشست کاربری شما منقضی شده است');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xzOPwsZ' } });

      return;

    }

    if (response.iResult == 0) return this._tooltip.showError(response.strError);

    this.lst_Report = response;

    this.lst_Search = response;

    this.obj_Report = { UsedSpaceMB: 0, DownloadedMB: 0, RemainderMB: 0 };

    this.lst_Report.forEach((el: any) => {

      this.obj_Report.UsedSpaceMB += el.UsedSpaceMB;

      this.obj_Report.DownloadedMB += el.DownloadedMB;

      this.obj_Report.RemainderMB += el.RemainderMB;


    })

  }

  filter_list(val: any) {

    this.lst_Report = this.lst_Search.filter((el: any) => {

      return el.strName.includes(val.value) ||

        el.strCityName.includes(val.value) ||

        el.strFullName.includes(val.value) ||

        el.iCode.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Report = this.lst_Search;

    }

  }

  Exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'وضعیت تخلیه فیلم ها.xlsx');
  }


}
